<template>
    <div class="container">
        <div class="scene">
            <canvas class="canvas" id="canvas-404"></canvas>
        </div>

        <div class="page-404__content">
            <a href="/" class="page-404__content-link text--reveal">Back to Home</a>
            <h1 class="page-404__content-title text--reveal">If you were looking for a page with totally nothing on it, tadaaa, found it!!</h1>
        </div>
    </div>
</template>

<script>
import { gsap } from 'gsap';

export default {
    mounted() {
        const initDelay = 0.2;
        gsap.delayedCall(initDelay, () => {
            // Let's make something cool!
            const {
                _: { debounce },
                Matter: {
                    Body,
                    Render,
                    Common,
                    Engine,
                    World,
                    Bodies,
                    Events,
                    Mouse,
                    MouseConstraint,
                    Composite,
                    Svg,
                    Vertices
                }
            } = window;
            // eslint-disable-next-line
   
            const desktopMultiplier = (window.innerWidth * 0.004);
            let multiplier = window.matchMedia('(max-width: 767px)').matches
                ? 2
                : desktopMultiplier;

            const scaleFactor = (57 * multiplier) / 57;

            const vertices4 = Vertices.scale([ { "x": 50.709, "y": 22.71 }, { "x": 39.059, "y": 22.71 }, { "x": 39.059, "y": 38.178 }, { "x": 21.684, "y": 38.178 }, { "x": 45.317, "y": -0.001 }, { "x": 31.62, "y": -0.001 }, { "x": 0.7809, "y": 49.82 }, { "x": 39.059, "y": 49.82 }, { "x": 39.059, "y": 59.999 }, { "x": 50.7089, "y": 59.999 }, { "x": 50.7089, "y": 49.82 }, { "x": 58.098, "y": 49.82 }, { "x": 64.83, "y": 38.178 }, { "x": 50.709, "y": 38.178 } ], scaleFactor, scaleFactor);

            
            const TEXTURES = [
                {
                    type: 'svg',
                    path: vertices4,
                    url: null,
                    width: 65 * multiplier,
                    height: 60 * multiplier,
                    xPosition: window.innerWidth / 2 - ((65 * multiplier) * 1),
                },
                {
                    type: 'image',
                    path: null,
                    url: '/media/images/0.svg',
                    width: 57 * multiplier,
                    height: 57 * multiplier,
                    xPosition: window.innerWidth / 2,
                },
                {
                    type: 'svg',
                    path: vertices4,
                    url: null,
                    width: 65 * multiplier,
                    height: 60 * multiplier,
                    xPosition: window.innerWidth / 2 + ((65 * multiplier) * 1)
                },
            ];

            const canvas = document.querySelector('#canvas-404');

            Common.setDecomp(require('poly-decomp'));

            const engine = Engine.create({
                // enableSleeping: true
            });

            const render = Render.create({
                element: '.scene',
                canvas,
                engine: engine,
                options: {
                    background: 'transparent',
                    wireframeBackground: 'transparent',
                    wireframes: false,
                    width: window.innerWidth,
                    height: window.innerHeight
                }
            });

            // Create the ground
            const ground = Bodies.rectangle(
                -100,
                window.innerHeight - 5,
                window.innerWidth * 5,
                1,
                {
                    isStatic: true,
                    render: {
                        opacity: 0
                    }
                }
            );

            const leftGround = Bodies.rectangle(
                -50,
                window.innerHeight - 5,
                1,
                window.innerHeight * 5,
                {
                    isStatic: true,
                    render: {
                        opacity: 0
                    }
                }
            );

            const rightGround = Bodies.rectangle(
                window.innerWidth + 50,
                window.innerHeight - 5,
                1,
                window.innerHeight * 5,
                {
                    isStatic: true,
                    render: {
                        opacity: 0
                    }
                }
            );

            // add all of the bodies to the world
            World.add(engine.world, [ground, leftGround, rightGround]);

            // run the engine
            Engine.run(engine);

            // run the renderer
            Render.run(render);

            var mouse = Mouse.create(render.canvas),
                mouseConstraint = MouseConstraint.create(engine, {
                    mouse: mouse,
                    constraint: {
                        stiffness: 0.2,
                        render: {
                            visible: false
                        }
                    }
                });
            
            mouseConstraint.mouse.element.removeEventListener("mousewheel", mouseConstraint.mouse.mousewheel);
            mouseConstraint.mouse.element.removeEventListener("DOMMouseScroll", mouseConstraint.mouse.mousewheel);

            Composite.add(engine.world, mouseConstraint);

            // keep the mouse in sync with rendering
            render.mouse = mouse;

            const addBear = () => {
                const HEADS = [];
                const amount = 3;

                for (let h = 0; h < amount; h++) {
                    const texture = TEXTURES[h];
                    let HEAD = null;
                    const MULTI = multiplier;

                    if(texture.path) {
                        HEAD = Bodies.fromVertices(
                            texture.xPosition,
                            window.innerHeight / 2 - (texture.height / 10),
                            texture.path,
                            {
                                render: {
                                    strokeStyle: '#ffffff',
                                    fillStyle: '#ffffff',
                                    lineWidth: 1.5,
                                }
                            },
                            true
                        );

                        if(h === 0) {
                            Body.rotate(HEAD, -Math.PI * 0.1);
                        }

                        if(h != 0) {
                            Body.rotate(HEAD, Math.PI * 0.1);
                        }
                    } else {
                        HEAD = Bodies.circle(
                        texture.xPosition,
                        window.innerHeight / 2 - (texture.width / 4),
                        texture.width / 2,
                        {
                            render: {
                                fillStyle: '#ffff00',
                                strokeStyle: '#ffffff',
                                sprite: {
                                    texture: texture.url,
                                    xScale: texture.width / 57,
                                    yScale: texture.width / 57
                                }
                            }
                        }
                    );
                    }

                    HEADS.push(HEAD);
                }

                World.add(engine.world, HEADS);
            };

            const mixed = () => addBear();
            const clear = () => World.clear(engine.world, true);

            // document.body.addEventListener('click', mixed);
            if (window.matchMedia('(min-width: 768px)').matches) {
                window.addEventListener(
                    'resize',
                    debounce(() => {
                        World.clear(engine.world, true);
                        canvas.width = window.innerWidth;
                        canvas.height = window.innerHeight;

                        const desktopMultiplier = (window.innerWidth * 0.004);
                        multiplier = window.matchMedia('(max-width: 767px)').matches
                            ? 2
                            : desktopMultiplier;
                        
                        Body.setPosition(ground, {
                            x: 0,
                            y: window.innerHeight - 10
                        });
                        mixed();
                    }, 500)
                );
            }


            mixed();
        });
    }
};
</script>

<style>
.container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
}

#canvas-404 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    /* background-color: white; */
    z-index: 100;
    pointer-events: none;
    overflow: hidden;
}

    @media only screen and (min-width: 768px)  {
        #canvas-404 {
            pointer-events: initial;
        }
    }
</style>
